import { STAMMDATEN_API } from '@Constants/backendConstants';
import { getFrameLabel } from '@Constants/getFrameLabel';
import { useHasSystemAccess } from '@Contexts/session/useHasSystemAccess';
import { ApiAvv } from '@Model';
import {
    Card,
    Checkbox,
    EditFrameMode,
    EditFrameShell,
    FrameEditBase,
    IFrameBodyProps,
    IFrameEditShellProps,
    TextInput,
    useFrameEditBaseNavigation,
    useGuiBinder,
    useTranslate,
} from '@synqo/frontend-component-library';
import { useParams } from 'react-router';

/**
 * AVVs are one catalogue shared by every mandant, only the seeding client may change them —
 * everywhere else this frame stays read-only.
 */
export function FrameEditAvv(props: IFrameEditShellProps<ApiAvv>) {
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();
    const hasSystemAccess = useHasSystemAccess();

    return (
        <FrameEditBase<ApiAvv>
            key={primaryKey}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
            apiResourcePath={`${STAMMDATEN_API}/avv`}
            renderer={FrameEditAvvBody}
            canEdit={props.canEdit !== false && hasSystemAccess}
            canCreate={props.canCreate !== false && hasSystemAccess}
            canDelete={props.canDelete !== false && hasSystemAccess}
            frameProps={{
                events: {
                    ...frameEditBaseNavigationEvents,
                    ...props.events,
                },
            }}
        />
    );
}

function FrameEditAvvBody(props: IFrameBodyProps<ApiAvv>) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiAvv>({
        ...props,
        canEdit: props.mode !== EditFrameMode.View,
    });

    return (
        <EditFrameShell
            headerProps={{
                label: getFrameLabel('Avv', props.mode),
                resourceLabel: 'AVV',
                ...props.events,
            }}
            bannerProps={{
                mode: props.mode,
                loading: props.stateQueueDepth > 0,
                ...props.events,
            }}
        >
            <Card name="AvvData" border={'withoutBorder'}>
                <TextInput {...binder.bindToProp<string>('code')} label={'Code'} />
                <Checkbox {...binder.bindToAutoConfirmed<boolean>('is_dangerous')} label={i18n('Gefährlich')} />
                <TextInput {...binder.bindToProp<string>('description')} inputSize={5} label={i18n('Beschreibung')} />
                <TextInput {...binder.bindToProp<string>('remarks')} inputSize={5} label={i18n('Bemerkung')} />
            </Card>
        </EditFrameShell>
    );
}
